import { render, staticRenderFns } from "./EventTeaser.vue?vue&type=template&id=ec264fac"
import script from "./EventTeaser.vue?vue&type=script&lang=js"
export * from "./EventTeaser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports